import React from 'react';
import Modal from './common/Modal';

const UPGRADE_PROMPT_TEXT = {
  ja: {
    title: 'PROプランのご案内',
    subtitle: '無料プランの保存上限に達しました。',
    message:
      'PROプランでは、保存スコア数の上限がなくなり、広告も非表示になります。引き続きご利用の場合は、プラン詳細ページをご確認ください。',
    cancel: 'あとで確認する',
    confirm: 'プラン詳細を見る',
  },
  en: {
    title: 'Upgrade to PRO',
    subtitle: 'You have reached the save limit on the FREE plan.',
    message:
      'With PRO, you can save unlimited scores and remove ads. Open the plan details page to continue.',
    cancel: 'Maybe later',
    confirm: 'View plan details',
  },
};

export default function UpgradePromptModal({ isOpen, locale, onClose, onConfirm }) {
  const text = UPGRADE_PROMPT_TEXT[locale] || UPGRADE_PROMPT_TEXT.en;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentClassName="modal-content--modern"
      contentProps={{ role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'upgrade-prompt-title' }}
    >
      <div className="modal-header">
        <h2 id="upgrade-prompt-title" className="modal-title">{text.title}</h2>
        <p className="modal-subtitle">{text.subtitle}</p>
      </div>
      <div className="modal-body">
        <p className="modal-message">{text.message}</p>
      </div>
      <div className="modal-footer modal-buttons">
        <button type="button" className="cancel" onClick={onClose}>
          {text.cancel}
        </button>
        <button type="button" className="create" onClick={onConfirm}>
          {text.confirm}
        </button>
      </div>
    </Modal>
  );
}
